export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";